import {
  ContentContainer,
  // ContentMenu,
  // ContentBody,
} from "@/pages/layouts/main-content";
import { Dashboard } from "@/pages/subs/home/dashboard";

export function MainHome() {
  return (
    <ContentContainer>
      <div className="w-full h-full flex flex-col">
        <Dashboard />
      </div>
    </ContentContainer>
  );
}
